import PropTypes from "prop-types";
import React from "react";

import { createClassNameString, generateRandomId } from "../utils";
import { getAutomationDataAttr } from "../../utils/automationUtils";
import { Image } from "../Image";
import { Popover } from "../Popover";
import { Portal } from "../Portal";

import "./styles.scss";

export const Info = ({ children, className, playwrightId, position, testId, ...props }) => {
  let toolTipId = generateRandomId() + "-tooltip";

  if (testId && process.env.REACT_APP_ENV !== "production") {
    toolTipId = testId;
  }

  return (
    <div className={createClassNameString(["apti-Info", position, className])} {...props}>
      <Image
        alt="info"
        data-for={toolTipId}
        data-tip="info-tooltip"
        src="icons/info_button.svg"
        {...getAutomationDataAttr(testId)}
        {...(playwrightId && { "data-testid": playwrightId })}
      />
      <Portal>
        <Popover className="apti-Info--popover" position={position} toolTipId={toolTipId}>
          {children}
        </Popover>
      </Portal>
    </div>
  );
};

Info.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  className: PropTypes.string,
  playwrightId: PropTypes.string,
  position: PropTypes.oneOf(["left", "right", "top", "bottom"]),
  testId: PropTypes.string,
};

Info.defaultProps = {
  children: <></>,
  className: undefined,
  playwrightId: undefined,
  position: "left",
  testId: undefined,
};
